module.exports = __webpack_public_path__ + "img/01_body_1200mk2_VG+.9f99e534.png";